export {
  isInboxSelected,
  toggleInboxSelection,
} from './inboxSelection';

export const canManagePublicMacros = ({
  isAdmin,
  isSupervisor,
}) => Boolean(isAdmin || isSupervisor);

export const buildMacroConversationParams = conversationId => ({
  conversation_id: conversationId,
});
